import React from 'react';
import TextClamp from '@opm/components/TextClamp';

interface IMemeAICellProps {
  record: any;
  isEn: boolean;
}

function MemeAICell({ record, isEn }: IMemeAICellProps) {
  const content = isEn ? record.content : (record.content_zh || record.content);
  return (
    <div className="dbom-meme-ai-text">
      <TextClamp
        rowNum={3}
        text={content || '-'}
      />
    </div>
  );
}

export default React.memo(MemeAICell);
